module.exports = {
  tag: 'xdr:xfrm',
  c: [
    {tag: 'a:off', $: {x: '0', y: '0'}},
    {tag: 'a:ext', $: {cx: '0', cy: '0'}},
  ],
};
